<template>
  <footer class="footer">
    <div class="container">
        <div class="copyright text-center">
          &copy; {{ new Date().getFullYear() }} Teatro Musicado, desenvolvido por<a href="https://espressolabs.com.br" target="_blank"> EspressoLabs </a>
        </div>
    </div>
  </footer>

</template>
<script>
export default {}

</script>
<style>

</style>
